export const isVideoFile = fileName => {
    if (!fileName) {
        return false
    }
    const url = new URL(fileName)
    return url?.pathname?.endsWith('mp4');
}